var moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

var numericFormatter = new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3
});

